import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'Quand faire une séance photo grossesse ?',
      answer: 'La séance photo grossesse se réalise idéalement entre la 7e et la 8e mois de grossesse (28-34 semaines). À ce stade, votre ventre est joliment arrondi et vous vous sentez encore bien dans votre corps. C\'est le moment parfait pour immortaliser cette période unique de votre vie. Je propose des séances grossesse à Haguenau, Strasbourg, Gundershoffen et dans tout le Bas-Rhin.'
    },
    {
      question: 'Que porter pour une séance maternité ?',
      answer: 'Pas d\'inquiétude ! Je mets à votre disposition une belle sélection de tenues soigneusement choisies : robes fluides, voiles bohème, bodys élégants, tissus délicats... Chaque pièce est pensée pour sublimer votre ventre rond avec raffinement. Vous pouvez aussi apporter vos propres tenues si vous le souhaitez. L\'objectif est que vous vous sentiez belle et confiante pendant votre séance photo grossesse.'
    },
    {
      question: 'Photographe maternité peut-il se déplacer à domicile ?',
      answer: 'Oui, je propose des séances à domicile en plus des séances en studio. Je me déplace à Haguenau, Gundershoffen, Strasbourg, Saverne, Bischwiller, Obernai, Wissembourg, Sélestat et dans tout le Bas-Rhin (67). Les séances à domicile permettent de capturer des moments intimes dans votre environnement familier. N\'hésitez pas à me contacter pour discuter de vos besoins !'
    },
    {
      question: 'Combien coûte une séance maternité à Haguenau ?',
      answer: 'Une séance photo grossesse démarre à 290€. Ce tarif comprend : la séance photo en studio dans une ambiance douce, la mise à disposition de tenues pour sublimer votre ventre rond, mon accompagnement personnalisé et bienveillant, ainsi que les retouches professionnelles de vos images. Je propose également un forfait Suivi Maternité à 549€ (au lieu de 659€) qui inclut une séance grossesse + une séance naissance.'
    },
    {
      question: 'Quand réserver sa séance grossesse ?',
      answer: 'Il est recommandé de réserver votre séance dès le 5e ou 6e mois de grossesse, même si la séance aura lieu au 7e-8e mois. Les créneaux se remplissent rapidement, surtout en haute saison. Une réservation anticipée vous garantit le meilleur choix de dates et me permet de bien préparer votre séance pour qu\'elle soit parfaite.'
    },
    {
      question: 'Quelle est la meilleure période pour photos nouveau-né ?',
      answer: 'Les photos de nouveau-né se réalisent idéalement entre 5 et 20 jours de vie, et au plus tard jusqu\'à 1 mois. Durant cette période, bébé dort profondément, se laisse facilement manipuler et adopte encore naturellement les positions fœtales si photogéniques. Je mets à disposition toutes les tenues et accessoires pour bébé dans mon studio à Haguenau.'
    },
    {
      question: 'Combien de temps dure une séance photo ?',
      answer: 'Une séance photo grossesse dure environ 1h à 1h30. Pour une séance nouveau-né, comptez 2 à 3 heures car nous respectons le rythme de bébé (pauses tétées, changes, câlins). Je ne suis jamais pressée : l\'important est de créer des images magnifiques dans une ambiance détendue et bienveillante.'
    },
    {
      question: 'Puis-je venir accompagnée à ma séance grossesse ?',
      answer: 'Absolument ! Votre compagnon et vos aînés sont les bienvenus pour partager ce moment unique. Les séances en famille créent de magnifiques souvenirs où l\'on voit toute la tendresse et l\'amour qui vous unit. C\'est aussi l\'occasion de créer des photos avec vos enfants attendant l\'arrivée du petit frère ou de la petite sœur.'
    },
    {
      question: 'Où se situe votre studio photo ?',
      answer: 'Mon studio photo se trouve à 15 minutes de Haguenau, en Alsace (Bas-Rhin 67). Je reçois des familles de toute la région : Haguenau, Gundershoffen, Strasbourg, Saverne, Bischwiller, Brumath, Obernai, Wissembourg, Sélestat, et même Mulhouse. Le studio est cosy, chaleureux et entièrement équipé pour accueillir les futures mamans et les nouveau-nés dans les meilleures conditions.'
    },
    {
      question: 'Comment se déroule la séance nouveau-né ?',
      answer: 'La séance nouveau-né se déroule dans le calme et la douceur, en respectant totalement le rythme de bébé. Le studio est bien chauffé (environ 28°C) pour le confort de votre tout-petit. Je propose plusieurs décors et accessoires. Nous faisons des pauses aussi souvent que nécessaire pour l\'alimentation et les câlins. Les parents peuvent aussi être photographiés avec leur bébé pour créer de tendres portraits de famille.'
    }
  ];

  return (
    <div className="bg-[#FAF8F5]">
      {/* Hero Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="font-heading text-4xl md:text-5xl font-semibold text-[#6B5845] mb-4">
              Questions Fréquentes
            </h1>
            <p className="font-heading text-xl text-[#8B7355]">
              Tout savoir sur les séances photo maternité et naissance
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white border border-[#E8DCC8] rounded-lg px-6"
              >
                <AccordionTrigger className="font-heading text-lg text-[#6B5845] hover:text-[#8B7355] py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-body text-base text-[#6B5845] leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
            Vous avez d'autres questions ?
          </h2>
          <p className="font-body text-base text-[#6B5845] leading-relaxed">
            N'hésitez pas à me contacter ! Je serai ravie de répondre à toutes vos questions et de vous accompagner dans la préparation de votre séance photo maternité ou naissance à Haguenau.
          </p>
          <Link to="/contact">
            <Button className="bg-[#8B7355] hover:bg-[#6B5845] text-white font-body px-8 py-6 text-base rounded-lg btn-primary">
              Contactez-moi
            </Button>
          </Link>
        </div>
      </section>

      {/* Instagram CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
            Suivez nos créations sur Instagram
          </h2>
          <p className="font-body text-base text-[#6B5845] leading-relaxed">
            Découvrez nos dernières séances photo maternité et naissance, nos coulisses et bien plus encore !
          </p>
          <a 
            href="https://www.instagram.com/yastudio_photography/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button className="bg-gradient-to-r from-[#E1306C] to-[#FD1D1D] hover:opacity-90 text-white font-body px-8 py-6 text-base rounded-lg btn-primary inline-flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Suivez-nous sur Instagram</span>
            </Button>
          </a>
        </div>
      </section>

      {/* Zone d'intervention */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
              Zone d'intervention
            </h2>
            <p className="font-body text-base text-[#6B5845] leading-relaxed max-w-4xl mx-auto">
              <strong>Photographe maternité et naissance à Haguenau</strong> - Je me déplace dans toute l'Alsace et le Bas-Rhin (67) : Haguenau, Gundershoffen, Strasbourg, Saverne, Bischwiller, Brumath, Obernai, Wissembourg, Sélestat, et bien au-delà.
            </p>
            <p className="font-body text-sm text-[#8B7355]">
              Mots-clés : photographe maternité Haguenau | photographe grossesse Gundershoffen | photographe maternité Strasbourg | séance photo grossesse Alsace | photographe nouveau-né Bas-Rhin | photographe maternité près de Saverne | séance maternité Wissembourg | photographe grossesse Obernai | séance photo ventre rond Haguenau
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
